import api from './api';

export interface Client {
    id: number;
    email: string;
    first_name: string;
    last_name: string;
    phone_number: string;
    appointments_count: number;
    orders_count: number;
    date_joined: string;
}

export const clientService = {
    getAll: async () => {
        const response = await api.get('users/clients/');
        return response.data;
    },
    create: async (data: Partial<Client>) => {
        const response = await api.post('users/clients/', data);
        return response.data;
    },
    delete: async (id: number) => {
        const response = await api.delete(`users/clients/${id}/`);
        return response.data;
    }
};
